// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header-title {
  background-color: #eee;
  padding: 1px;
}

h4 {
  color: #003561;
  margin: 8px 3px;
  font-size: 12px;
  letter-spacing: 1px;
  font-weight: 400;
  font-family: 'Inter Regular';
  /* margin-left: 0px; */
}

.side-list h4 {
  display: inline-flex;
}

.content-text {
  border-bottom: 1px#eee solid;
  padding: 20px;
  border-bottom: 1px #eee solid;
  padding-bottom: 50px;
}

.header-title .mat-icon {
  background-repeat: no-repeat;
  display: inline-block;
  fill: currentColor;
  height: 24px;
  width: 24px;
  margin-right: 16px;
  vertical-align: middle;
}

.custom-input input {
  border: 1px #ddd solid;
  height: 20px;
  border-radius: 5px;
  padding: 2px;
  margin: 4px;
  margin-left: 0px;
  width: 60px;
  font-size: 10px;
  text-align: center;
  letter-spacing: 1px;
}

.width-100 {
  width: 100%;
}

.width-88 {
  width: 88%;
}

::ng-deep .color-picker {
  top: 240px !important;
  left: 25px !important;
}

.form-control {
  font-family: 'Inter Regular';
  border: 1px #eee solid;
  padding: 5px;
  border-radius: 4px;
}

.form-control mat-label {
  font-size: 12px;
  font-weight: 400;
  color: #666;
  letter-spacing: 1px;
  width: 35%;
}

.content-text ::ng-deep .mat-checkbox-layout .mat-checkbox-label {
  font-size: 14px;
  font-family: 'Inter Regular';
  letter-spacing: 1px;
  color: #555;
}

.form-control p {
  margin: 5px 0px;
}

.radio-select {
  font-size: 14px;
}

.mr-15 {
  margin-right: 15px;
}

.ptb-5 {
  padding: 5px 0px;
  border-bottom: 1px #eee solid;
}

.align-center {
  text-align: center;
}

.borderview {
  background: #fff !important;
}

.add-text {
  font-size: 14px;
  font-weight: bold;
  letter-spacing: 1px;
  font-family: 'Inter Regular';
  margin-top: 0px;
}

.add-text .mat-stroked-button {
  height: 30px;
  font-size: 12px;
  line-height: 30px;
  padding: 0px 5px;
}

.browse-input {
  opacity: 0;
  width: 100%;
  position: absolute;
  z-index: 2;
  margin: 0;
  left: 0px;
  padding: 10px 0px;
}

.browse-file {
  border: 1px #eee solid;
  margin: 10px 0px;
  border-radius: 4px;
  font-family: 'Inter Regular';
  text-align: center;
  position: relative;
  cursor: pointer;
  height: 30px;
  float: left;
  width: 85%;
  background-color: #fff;
}

.browse-btn {
  float: left;
  padding: 0px 12px;
  background-color: #f2f2f2;
  color: #666;
  font-size: 12px;
  height: 30px;
  line-height: 29px;
}

/* ::ng-deep .mat-form-field-wrapper {
  padding-bottom: 0em;
  background-color: #fff;
} */
.addlink {
  border-bottom: 1px #fff solid;
}

.input-field :host ::ng-deep .mat-form-field-appearance-outline .mat-form-field-infix {
  padding: 1em 0 0em 0 !important;
  margin-top: -12px !important;
  height: 30px !important;
  line-height: 0px !important;
  font-size: 14px;
}

.input-field :host ::ng-deep .mat-form-field-appearance-outline .mat-select-arrow-wrapper {
  padding-top: 18px !important;
}

.mr-5 {
  margin-right: 5px;
}

.mt-8 {
  margin-top: 8px;
}

.linkclose {
  background-color: #003561;
  color: #fff;
  padding: 3px 3px 1px 2px;
  height: 22px;
  position: relative;
  left: 5px;
  border-radius: 100px;
}

.linkclose .material-icons {
  pointer-events: all;
  cursor: pointer;
  z-index: 9999;
  font-size: 15px;
  padding: 1px;
}

.form-control ::ng-deep .mat-radio-inner-circle {
  height: 15px !important;
  width: 15px !important;
  margin-top: 2px;
}

.width-90 {
  width: 90%;
}

.form-control ::ng-deep .mat-radio-outer-circle {
  height: 15px !important;
  width: 15px !important;
  margin-top: 2px;
}

.form-control ::ng-deep .mat-radio-label {
  font-size: 14px;
}

.m-0 {
  margin: 0px;
}

.p-4 {
  padding: 4px;
}

.file-name {
  float: left;
  padding: 2px 10px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  word-break: break-all;
  max-width: 300px;
  margin: 6px 0px;
  color: #333;
  width: 100%;
}

.file-name p {
  margin: 0px;
  font-size: 12px;
  letter-spacing: 1px;
}

.image-preview {
  float: left;
  padding: 3px 6px;
  /* right: 30px;
  position: absolute; */
}

.image-preview img {
  height: 25px;
}

.pl-15 {
  padding-left: 15px;
}

.pt-15 {
  padding-top: 15px;
}

.map-title ::ng-deep .mat-form-field-wrapper {
  padding-bottom: 0.5em;
}

.content-text ::ng-deep .mat-fab {
  position: sticky;
  bottom: 10px;
  right: 10px;
  float: right;
  font-family: 'Inter Regular';
  border-radius: 5px;
  width: max-content;
  height: auto;
  padding: 0 8px;
}

.content-text ::ng-deep .mat-fab .mat-button-wrapper {
  padding: 10px;
}

.show-bg {
  border: 1px #ddd solid;
  background-color: #fff;
  border-radius: 7px;
  padding: 0px 10px;
}

.margin-input {
  margin: 10px 15px;
}

.embmapdiv {
  background: #eee;
  padding: 10px 0px 3px;
  border: 1px solid #ddd;
  border-radius: 5px;
}

.mat-error {
  display: block;
  font-size: 13px;
}

.width-100 {
  width: 100%;
}

.p-5 {
  padding: 5px;
}

::ng-deep .mat-form-field-appearance-outline .mat-select-arrow-wrapper {
  padding-top: 10px;
}

@media (max-width: 768px) {

  .form-control mat-label {
    width: 90% !important;
  }

  .ml-50 {
    margin-left: 0px !important;
  }

  .browse-file {
    height: auto !important;
  }

  .browse-btn {
    float: none !important;
  }

  .width-50 {
    width: 100%;
  }
}

.mainClass {
  border-bottom: 2px solid #ffcc00;

}

.mat-drawer-content {
  position: relative;
  z-index: 1;
  display: block;
  height: 100vh !important;
  overflow: hidden !important;
}

.sharmapdiv {
  height: calc(100vh - 48px);
  overflow: auto;
}

.sideNav {
  border: 2px solid #ddd;
  margin: 10px 10px 10px 0px;

}

.mapHeader {
  border: 2px solid #003561;
  background: rgba(255, 255, 255, 0.8);
  width: 99%;
  position: absolute;
}

::ng-deep .leaflet-popup-content::-webkit-scrollbar,
.scroll-bar::-webkit-scrollbar,
.mat-drawer::-webkit-scrollbar,
::ng-deep .mat-dialog-container::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}

::ng-deep .leaflet-popup-content::-webkit-scrollbar-thumb,
.scroll-bar::-webkit-scrollbar-thumb,
.mat-drawer::-webkit-scrollbar-thumb,
::ng-deep .mat-dialog-container::-webkit-scrollbar-thumb {
  background: #003561;
  border-radius: 20px;
}

::ng-deep .leaflet-popup-content::-webkit-scrollbar-track,
.scroll-bar::-webkit-scrollbar-track,
.mat-drawer::-webkit-scrollbar-track,
::ng-deep .mat-dialog-container::-webkit-scrollbar-track {
  background: #ddd;
  border-radius: 20px;
}

.right-menu {
  float: right;
  padding-top: 0px;
}

.img-wh {
  width: 100%;
  height: 100%;
}

/* .chart-img {
  width: 100%;
  height: 37%;
} */
.p-15 {
  padding: 0px 15px;
}

.border-1 {
  border: 1px #ddd solid;
  background: #eee;
  padding: 5px;
  border-radius: 4px;
  margin-bottom: 8px;
}

.footer-box {
  padding: 8px 15px;
  background-color: #fff;
  margin: 10px;
  border: 2px solid #ddd;
  text-align: center;
}

.mat-raised-button.mat-accent {
  background-color: #003561 !important;
  color: #fff !important;
}

.close-btn {
  text-align: right;
  position: absolute;
  top: 6px;
  right: 50px;
}

.close-btn .material-icons {
  border: 1px #ddd solid;
  border-radius: 50px;
  position: absolute;
  background-color: #fff;
}

@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation : portrait) {
  .sharemavflex {
    max-width: 55% !important;
  }

  .menubtn {
    display: block !important;
  }
}

/* .scrolldivs {
  position: relative;
  height: calc(100vh - 40px);
} */

.menubtn mat-icon {
  background: #003561;
  padding: 8px !important;
  font-size: 22px;
  display: inline-table;
  border-radius: 50%;
  color: #fff;
}

.mat-menu-item {
  line-height: 35px !important;
  height: 35px !important;
}

.btn-icon {
  float: left;
  padding-top: 5px;
}

/* .drag-icon .material-icons {
  font-size: 17px;
  height: 15px;
  width: 25px;
  padding-top: 8px;
}
.drag-icon:hover {
    background-color: #fff;
} */

::ngdeep .maintainanceHeader {
  display: none !important;
}

.chart-box-tb {
  overflow: auto;
  float: left;
}

.chart-box-tb .chartMainClass {
  float: left;
}

.chart-box {
  height: calc(100vh - 52px);
  margin-top: 20%;
  overflow: auto;
}

/* .mapContent .add_layer {
  position: relative;
  top: auto;
  width: 50%;
}
.mapContent .add_layer p {
    margin: 0px;
    text-align: center;
}
.mapContent {
  margin-top: 40px;
} */

.p-0-15 {
  padding: 0px 15px;
}

.custom-input {
  float: left;
}

.highlight_Color {
  border-radius: 0px;
  padding-right: 0px;
  border: none;
  padding-left: 0px;
}

.highlight_Color mat-label {
  width: auto;
  padding-top: 2px;
  padding-right: 4px;
}

.navbar_Color {
  width: 100%;
  float: left;
  margin-right: 10px;
}

.navbar_color_box {
  width: 50%;
  float: left;
  border: none;
  padding-left: 10px;
  padding-right: 0px;
}

.navbar_Color mat-label {
  width: auto;
  padding-top: 5px;
}

::-webkit-scrollbar {
  width: 8px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #003561;
  border-radius: 10px;
}



/* Start Css By Balram */

.share-map {
  border: 1px solid lightgray;
  border-style: double;
  border-radius: 6px;
  background-color: #eee;
  margin-top: 23px;
}

.map-titleview {
  background: #fff;
  padding: 10px;
  border-radius: 7px;
  border: 1px solid #ddd;
}

/* End Css By Balram */

@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation : portrait) {
  .sidenav {
    max-width: 35% !important;
  }

  .menubtn {
    display: block !important;
  }

  .cartoviewsfx {
    max-width: 35% !important;
  }
}



.mapisochrone {
  position: relative;
}


.menubtn mat-icon {
  background: #003561;
  padding: 8px !important;
  font-size: 22px;
  display: inline-table;
  border-radius: 50%;
  color: #fff;
}

.show-bg ::ng-deep .mat-form-field-wrapper {
  padding-bottom: 0em;
}

.map-titleview ::ng-deep .mat-form-field-wrapper {
  padding-bottom: 0em;
}

.width-100 {
  width: 100%;
}

span.addmore {
  margin-left: 3px;
  display: inline-block;
}

.mat-stepperdiv {
  max-height: calc(100vh - 220px);

}

.mat-toolbarhead {

  position: relative;
  z-index: 99;
  box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%);


}

.logo {
  height: 20px;
  cursor: pointer;
  margin-top: 8px;
}

.mat-card {
  font-family: 'Inter Regular';
  letter-spacing: 0.5px;
}

.mat-toolbar-row {
  padding: 0 10px !important;
  height: 50px;
}

.menu-spacer {
  flex: 1 1 auto;
}

.nav-menu {
  display: inline;
}

.nav-menu .item-nav {
  float: left;
}

.nav-menu .close-btn {
  display: none;
}

@media (max-width: 768px) {
  .menu-icon {
    position: absolute;
    right: 10px;
  }

  .nav-menu .close-btn {
    display: block;
  }

  .close-btn {
    text-align: right;
    margin-top: 0px;
    position: absolute;
    right: 10px;
    top: 9px;
  }

  .close-btn .material-icons {
    padding: 5px;
    border: 1px #ddd solid;
    border-radius: 50px;
    background-color: #fff;
  }

  .nav-menu {
    display: none;
    top: 50px;
    position: fixed;
    background-color: #003561;
    width: 100%;
    height: 100%;
    left: 0px;
    padding: 15px 0px;
  }

  .nav-menu .item-nav {
    width: 100%;
    text-align: center;
  }

  .nav-menu .item-nav:hover {
    background-color: #1d66a3;
  }

  .nav-menu-m {
    display: inline-block !important;
  }

  .layer-content {
    width: 190px !important;
  }

  .map-title {
    width: 70px !important;
  }

  .layer-menu-siderbar {
    width: 200px !important;
  }

  ::ng-deep .mat-list-base .mat-list-item .mat-list-item-content,
  .mat-list-base .mat-list-option .mat-list-item-content {
    padding: 0 5px !important;
  }

  .layer-style-list .material-icons {
    font-size: 18px !important;
    padding-right: 4px !important;
  }

  .show-legeand-sidebar {
    bottom: 40px !important;
  }

  .layers-name {
    max-width: 70px !important;
  }

  .layer-style-list img {
    width: 20px;
    height: 20px;
  }

}

.close-btn {
  text-align: right;
  font-size: 16px;
  margin-top: 5px;
  position: absolute;
  right: 8px;
}

.close-btn .material-icons {
  padding: 5px;
  border: 1px #ddd solid;
  border-radius: 50px;
  background-color: #fff;
}

.mat-toolbar-multiple-rows {
  border-bottom: 1px #eee solid;
  min-height: 50px;
}


.tools-operation {
  position: relative;
  background: #fff;
  left: 0;
  right: 0;
  margin: 0 auto;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9;
  padding: 2px 0px 5px;
}



.mat-cards {
  border-top: 1px solid #003561;
  border-bottom: 1px solid #003561;
  padding: 8px !important;
}

.mat-stepperdiv {
  height: calc(100vh - 50px);
  max-height: unset;
}

.bodyview {
  position: relative;
  z-index: 1;
  display: block;
  overflow: hidden;
}

.scrolldivs {
  height: calc(100vh);
}

.side-list {
  display: flex;
  justify-content: center;
  align-items: center;
}

.mat-tools {
  height: 50px;
}

:host ::ng-deep .show-legeand-sidebar {
  background: transparent !important;
}

.desktopview {
  flex: 1 1 100%;
  box-sizing: border-box;
  /* max-height: 20%; */
  margin: 0px 10px 0px 10px;
  border: 9px solid #20609c;
  border-radius: 9px;
  height: 94vh;
  z-index: 99999;
}

.divflex {
  position: relative;
}

.menu-divflex {
  border-right: 1px solid #909090;
  width: 70px;
  background: #fff;
}

.details .menuBtn {
  line-height: 30px !important;
}

img.img-dash {
  height: 17px;
  margin-right: 8px;
}

.logo-dash {
  height: 24px;
  position: relative;
  top: 1px;
}

.dflex {
  display: flex;
}

:host ::ng-deep .mat-menu-content:not(:empty) {
  padding: 0 !important;
}

.headmap {
  padding: 5px 7px;
  background: #ddd;
  border-radius: 0px;
}

.headmap h2 {
  font-size: 14px;
}

.add-icon {
  color: #fff !important;
}

.share-icon {
  font-size: 20px;
  height: 20px;
  width: 20px;
}`, "",{"version":3,"sources":["webpack://./src/app/app-share-map-module/map-preview/map-preview.component.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,4BAA4B;EAC5B,aAAa;EACb,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;EACE,4BAA4B;EAC5B,qBAAqB;EACrB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,4BAA4B;EAC5B,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,4BAA4B;EAC5B,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,WAAW;EACX,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB,WAAW;EACX,eAAe;EACf,YAAY;EACZ,iBAAiB;AACnB;;AAEA;;;GAGG;AACH;EACE,6BAA6B;AAC/B;;AAEA;EACE,+BAA+B;EAC/B,4BAA4B;EAC5B,uBAAuB;EACvB,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,wBAAwB;EACxB,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,eAAe;EACf,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,WAAW;AACb;;AAEA;EACE,WAAW;EACX,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB;uBACqB;AACvB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,4BAA4B;EAC5B,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;EAEE;IACE,qBAAqB;EACvB;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE,gCAAgC;;AAElC;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,cAAc;EACd,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,0BAA0B;;AAE5B;;AAEA;EACE,yBAAyB;EACzB,oCAAoC;EACpC,UAAU;EACV,kBAAkB;AACpB;;AAEA;;;;EAIE,WAAW;EACX,YAAY;AACd;;AAEA;;;;EAIE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;;;;EAIE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;;;GAGG;AACH;EACE,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;;;GAGG;;AAEH;EACE,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,4BAA4B;EAC5B,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;;;;;;;;GAQG;;AAEH;EACE,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,0BAA0B;EAC1B,eAAe;EACf,cAAc;AAChB;;AAEA;;;;;;;;;;;GAWG;;AAEH;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA,UAAU;AACV;EACE,mBAAmB;AACrB;;AAEA,WAAW;AACX;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;;;AAIA,wBAAwB;;AAExB;EACE,2BAA2B;EAC3B,oBAAoB;EACpB,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA,sBAAsB;;AAEtB;EACE;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;AACF;;;;AAIA;EACE,kBAAkB;AACpB;;;AAGA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,+BAA+B;;AAEjC;;AAEA;;EAEE,kBAAkB;EAClB,WAAW;EACX,iHAAiH;;;AAGnH;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;EAC1B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,kBAAkB;IAClB,WAAW;EACb;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,kBAAkB;IAClB,WAAW;IACX,QAAQ;EACV;;EAEA;IACE,YAAY;IACZ,sBAAsB;IACtB,mBAAmB;IACnB,sBAAsB;EACxB;;EAEA;IACE,aAAa;IACb,SAAS;IACT,eAAe;IACf,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,SAAS;IACT,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;IAEE,yBAAyB;EAC3B;;EAEA;IACE,0BAA0B;IAC1B,6BAA6B;EAC/B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;AAEF;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;AAClB;;;AAGA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,OAAO;EACP,QAAQ;EACR,cAAc;EACd,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,UAAU;EACV,oBAAoB;AACtB;;;;AAIA;EACE,6BAA6B;EAC7B,gCAAgC;EAChC,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,qBAAqB;EACrB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,WAAW;AACb","sourcesContent":[".header-title {\n  background-color: #eee;\n  padding: 1px;\n}\n\nh4 {\n  color: #003561;\n  margin: 8px 3px;\n  font-size: 12px;\n  letter-spacing: 1px;\n  font-weight: 400;\n  font-family: 'Inter Regular';\n  /* margin-left: 0px; */\n}\n\n.side-list h4 {\n  display: inline-flex;\n}\n\n.content-text {\n  border-bottom: 1px#eee solid;\n  padding: 20px;\n  border-bottom: 1px #eee solid;\n  padding-bottom: 50px;\n}\n\n.header-title .mat-icon {\n  background-repeat: no-repeat;\n  display: inline-block;\n  fill: currentColor;\n  height: 24px;\n  width: 24px;\n  margin-right: 16px;\n  vertical-align: middle;\n}\n\n.custom-input input {\n  border: 1px #ddd solid;\n  height: 20px;\n  border-radius: 5px;\n  padding: 2px;\n  margin: 4px;\n  margin-left: 0px;\n  width: 60px;\n  font-size: 10px;\n  text-align: center;\n  letter-spacing: 1px;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n.width-88 {\n  width: 88%;\n}\n\n::ng-deep .color-picker {\n  top: 240px !important;\n  left: 25px !important;\n}\n\n.form-control {\n  font-family: 'Inter Regular';\n  border: 1px #eee solid;\n  padding: 5px;\n  border-radius: 4px;\n}\n\n.form-control mat-label {\n  font-size: 12px;\n  font-weight: 400;\n  color: #666;\n  letter-spacing: 1px;\n  width: 35%;\n}\n\n.content-text ::ng-deep .mat-checkbox-layout .mat-checkbox-label {\n  font-size: 14px;\n  font-family: 'Inter Regular';\n  letter-spacing: 1px;\n  color: #555;\n}\n\n.form-control p {\n  margin: 5px 0px;\n}\n\n.radio-select {\n  font-size: 14px;\n}\n\n.mr-15 {\n  margin-right: 15px;\n}\n\n.ptb-5 {\n  padding: 5px 0px;\n  border-bottom: 1px #eee solid;\n}\n\n.align-center {\n  text-align: center;\n}\n\n.borderview {\n  background: #fff !important;\n}\n\n.add-text {\n  font-size: 14px;\n  font-weight: bold;\n  letter-spacing: 1px;\n  font-family: 'Inter Regular';\n  margin-top: 0px;\n}\n\n.add-text .mat-stroked-button {\n  height: 30px;\n  font-size: 12px;\n  line-height: 30px;\n  padding: 0px 5px;\n}\n\n.browse-input {\n  opacity: 0;\n  width: 100%;\n  position: absolute;\n  z-index: 2;\n  margin: 0;\n  left: 0px;\n  padding: 10px 0px;\n}\n\n.browse-file {\n  border: 1px #eee solid;\n  margin: 10px 0px;\n  border-radius: 4px;\n  font-family: 'Inter Regular';\n  text-align: center;\n  position: relative;\n  cursor: pointer;\n  height: 30px;\n  float: left;\n  width: 85%;\n  background-color: #fff;\n}\n\n.browse-btn {\n  float: left;\n  padding: 0px 12px;\n  background-color: #f2f2f2;\n  color: #666;\n  font-size: 12px;\n  height: 30px;\n  line-height: 29px;\n}\n\n/* ::ng-deep .mat-form-field-wrapper {\n  padding-bottom: 0em;\n  background-color: #fff;\n} */\n.addlink {\n  border-bottom: 1px #fff solid;\n}\n\n.input-field :host ::ng-deep .mat-form-field-appearance-outline .mat-form-field-infix {\n  padding: 1em 0 0em 0 !important;\n  margin-top: -12px !important;\n  height: 30px !important;\n  line-height: 0px !important;\n  font-size: 14px;\n}\n\n.input-field :host ::ng-deep .mat-form-field-appearance-outline .mat-select-arrow-wrapper {\n  padding-top: 18px !important;\n}\n\n.mr-5 {\n  margin-right: 5px;\n}\n\n.mt-8 {\n  margin-top: 8px;\n}\n\n.linkclose {\n  background-color: #003561;\n  color: #fff;\n  padding: 3px 3px 1px 2px;\n  height: 22px;\n  position: relative;\n  left: 5px;\n  border-radius: 100px;\n}\n\n.linkclose .material-icons {\n  pointer-events: all;\n  cursor: pointer;\n  z-index: 9999;\n  font-size: 15px;\n  padding: 1px;\n}\n\n.form-control ::ng-deep .mat-radio-inner-circle {\n  height: 15px !important;\n  width: 15px !important;\n  margin-top: 2px;\n}\n\n.width-90 {\n  width: 90%;\n}\n\n.form-control ::ng-deep .mat-radio-outer-circle {\n  height: 15px !important;\n  width: 15px !important;\n  margin-top: 2px;\n}\n\n.form-control ::ng-deep .mat-radio-label {\n  font-size: 14px;\n}\n\n.m-0 {\n  margin: 0px;\n}\n\n.p-4 {\n  padding: 4px;\n}\n\n.file-name {\n  float: left;\n  padding: 2px 10px;\n  overflow: hidden;\n  display: -webkit-box;\n  -webkit-line-clamp: 1;\n  -webkit-box-orient: vertical;\n  word-break: break-all;\n  max-width: 300px;\n  margin: 6px 0px;\n  color: #333;\n  width: 100%;\n}\n\n.file-name p {\n  margin: 0px;\n  font-size: 12px;\n  letter-spacing: 1px;\n}\n\n.image-preview {\n  float: left;\n  padding: 3px 6px;\n  /* right: 30px;\n  position: absolute; */\n}\n\n.image-preview img {\n  height: 25px;\n}\n\n.pl-15 {\n  padding-left: 15px;\n}\n\n.pt-15 {\n  padding-top: 15px;\n}\n\n.map-title ::ng-deep .mat-form-field-wrapper {\n  padding-bottom: 0.5em;\n}\n\n.content-text ::ng-deep .mat-fab {\n  position: sticky;\n  bottom: 10px;\n  right: 10px;\n  float: right;\n  font-family: 'Inter Regular';\n  border-radius: 5px;\n  width: max-content;\n  height: auto;\n  padding: 0 8px;\n}\n\n.content-text ::ng-deep .mat-fab .mat-button-wrapper {\n  padding: 10px;\n}\n\n.show-bg {\n  border: 1px #ddd solid;\n  background-color: #fff;\n  border-radius: 7px;\n  padding: 0px 10px;\n}\n\n.margin-input {\n  margin: 10px 15px;\n}\n\n.embmapdiv {\n  background: #eee;\n  padding: 10px 0px 3px;\n  border: 1px solid #ddd;\n  border-radius: 5px;\n}\n\n.mat-error {\n  display: block;\n  font-size: 13px;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n.p-5 {\n  padding: 5px;\n}\n\n::ng-deep .mat-form-field-appearance-outline .mat-select-arrow-wrapper {\n  padding-top: 10px;\n}\n\n@media (max-width: 768px) {\n\n  .form-control mat-label {\n    width: 90% !important;\n  }\n\n  .ml-50 {\n    margin-left: 0px !important;\n  }\n\n  .browse-file {\n    height: auto !important;\n  }\n\n  .browse-btn {\n    float: none !important;\n  }\n\n  .width-50 {\n    width: 100%;\n  }\n}\n\n.mainClass {\n  border-bottom: 2px solid #ffcc00;\n\n}\n\n.mat-drawer-content {\n  position: relative;\n  z-index: 1;\n  display: block;\n  height: 100vh !important;\n  overflow: hidden !important;\n}\n\n.sharmapdiv {\n  height: calc(100vh - 48px);\n  overflow: auto;\n}\n\n.sideNav {\n  border: 2px solid #ddd;\n  margin: 10px 10px 10px 0px;\n\n}\n\n.mapHeader {\n  border: 2px solid #003561;\n  background: rgba(255, 255, 255, 0.8);\n  width: 99%;\n  position: absolute;\n}\n\n::ng-deep .leaflet-popup-content::-webkit-scrollbar,\n.scroll-bar::-webkit-scrollbar,\n.mat-drawer::-webkit-scrollbar,\n::ng-deep .mat-dialog-container::-webkit-scrollbar {\n  width: 10px;\n  height: 10px;\n}\n\n::ng-deep .leaflet-popup-content::-webkit-scrollbar-thumb,\n.scroll-bar::-webkit-scrollbar-thumb,\n.mat-drawer::-webkit-scrollbar-thumb,\n::ng-deep .mat-dialog-container::-webkit-scrollbar-thumb {\n  background: #003561;\n  border-radius: 20px;\n}\n\n::ng-deep .leaflet-popup-content::-webkit-scrollbar-track,\n.scroll-bar::-webkit-scrollbar-track,\n.mat-drawer::-webkit-scrollbar-track,\n::ng-deep .mat-dialog-container::-webkit-scrollbar-track {\n  background: #ddd;\n  border-radius: 20px;\n}\n\n.right-menu {\n  float: right;\n  padding-top: 0px;\n}\n\n.img-wh {\n  width: 100%;\n  height: 100%;\n}\n\n/* .chart-img {\n  width: 100%;\n  height: 37%;\n} */\n.p-15 {\n  padding: 0px 15px;\n}\n\n.border-1 {\n  border: 1px #ddd solid;\n  background: #eee;\n  padding: 5px;\n  border-radius: 4px;\n  margin-bottom: 8px;\n}\n\n.footer-box {\n  padding: 8px 15px;\n  background-color: #fff;\n  margin: 10px;\n  border: 2px solid #ddd;\n  text-align: center;\n}\n\n.mat-raised-button.mat-accent {\n  background-color: #003561 !important;\n  color: #fff !important;\n}\n\n.close-btn {\n  text-align: right;\n  position: absolute;\n  top: 6px;\n  right: 50px;\n}\n\n.close-btn .material-icons {\n  border: 1px #ddd solid;\n  border-radius: 50px;\n  position: absolute;\n  background-color: #fff;\n}\n\n@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation : portrait) {\n  .sharemavflex {\n    max-width: 55% !important;\n  }\n\n  .menubtn {\n    display: block !important;\n  }\n}\n\n/* .scrolldivs {\n  position: relative;\n  height: calc(100vh - 40px);\n} */\n\n.menubtn mat-icon {\n  background: #003561;\n  padding: 8px !important;\n  font-size: 22px;\n  display: inline-table;\n  border-radius: 50%;\n  color: #fff;\n}\n\n.mat-menu-item {\n  line-height: 35px !important;\n  height: 35px !important;\n}\n\n.btn-icon {\n  float: left;\n  padding-top: 5px;\n}\n\n/* .drag-icon .material-icons {\n  font-size: 17px;\n  height: 15px;\n  width: 25px;\n  padding-top: 8px;\n}\n.drag-icon:hover {\n    background-color: #fff;\n} */\n\n::ngdeep .maintainanceHeader {\n  display: none !important;\n}\n\n.chart-box-tb {\n  overflow: auto;\n  float: left;\n}\n\n.chart-box-tb .chartMainClass {\n  float: left;\n}\n\n.chart-box {\n  height: calc(100vh - 52px);\n  margin-top: 20%;\n  overflow: auto;\n}\n\n/* .mapContent .add_layer {\n  position: relative;\n  top: auto;\n  width: 50%;\n}\n.mapContent .add_layer p {\n    margin: 0px;\n    text-align: center;\n}\n.mapContent {\n  margin-top: 40px;\n} */\n\n.p-0-15 {\n  padding: 0px 15px;\n}\n\n.custom-input {\n  float: left;\n}\n\n.highlight_Color {\n  border-radius: 0px;\n  padding-right: 0px;\n  border: none;\n  padding-left: 0px;\n}\n\n.highlight_Color mat-label {\n  width: auto;\n  padding-top: 2px;\n  padding-right: 4px;\n}\n\n.navbar_Color {\n  width: 100%;\n  float: left;\n  margin-right: 10px;\n}\n\n.navbar_color_box {\n  width: 50%;\n  float: left;\n  border: none;\n  padding-left: 10px;\n  padding-right: 0px;\n}\n\n.navbar_Color mat-label {\n  width: auto;\n  padding-top: 5px;\n}\n\n::-webkit-scrollbar {\n  width: 8px;\n}\n\n/* Track */\n::-webkit-scrollbar-track {\n  background: #f1f1f1;\n}\n\n/* Handle */\n::-webkit-scrollbar-thumb {\n  background: #003561;\n  border-radius: 10px;\n}\n\n\n\n/* Start Css By Balram */\n\n.share-map {\n  border: 1px solid lightgray;\n  border-style: double;\n  border-radius: 6px;\n  background-color: #eee;\n  margin-top: 23px;\n}\n\n.map-titleview {\n  background: #fff;\n  padding: 10px;\n  border-radius: 7px;\n  border: 1px solid #ddd;\n}\n\n/* End Css By Balram */\n\n@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation : portrait) {\n  .sidenav {\n    max-width: 35% !important;\n  }\n\n  .menubtn {\n    display: block !important;\n  }\n\n  .cartoviewsfx {\n    max-width: 35% !important;\n  }\n}\n\n\n\n.mapisochrone {\n  position: relative;\n}\n\n\n.menubtn mat-icon {\n  background: #003561;\n  padding: 8px !important;\n  font-size: 22px;\n  display: inline-table;\n  border-radius: 50%;\n  color: #fff;\n}\n\n.show-bg ::ng-deep .mat-form-field-wrapper {\n  padding-bottom: 0em;\n}\n\n.map-titleview ::ng-deep .mat-form-field-wrapper {\n  padding-bottom: 0em;\n}\n\n.width-100 {\n  width: 100%;\n}\n\nspan.addmore {\n  margin-left: 3px;\n  display: inline-block;\n}\n\n.mat-stepperdiv {\n  max-height: calc(100vh - 220px);\n\n}\n\n.mat-toolbarhead {\n\n  position: relative;\n  z-index: 99;\n  box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%);\n\n\n}\n\n.logo {\n  height: 20px;\n  cursor: pointer;\n  margin-top: 8px;\n}\n\n.mat-card {\n  font-family: 'Inter Regular';\n  letter-spacing: 0.5px;\n}\n\n.mat-toolbar-row {\n  padding: 0 10px !important;\n  height: 50px;\n}\n\n.menu-spacer {\n  flex: 1 1 auto;\n}\n\n.nav-menu {\n  display: inline;\n}\n\n.nav-menu .item-nav {\n  float: left;\n}\n\n.nav-menu .close-btn {\n  display: none;\n}\n\n@media (max-width: 768px) {\n  .menu-icon {\n    position: absolute;\n    right: 10px;\n  }\n\n  .nav-menu .close-btn {\n    display: block;\n  }\n\n  .close-btn {\n    text-align: right;\n    margin-top: 0px;\n    position: absolute;\n    right: 10px;\n    top: 9px;\n  }\n\n  .close-btn .material-icons {\n    padding: 5px;\n    border: 1px #ddd solid;\n    border-radius: 50px;\n    background-color: #fff;\n  }\n\n  .nav-menu {\n    display: none;\n    top: 50px;\n    position: fixed;\n    background-color: #003561;\n    width: 100%;\n    height: 100%;\n    left: 0px;\n    padding: 15px 0px;\n  }\n\n  .nav-menu .item-nav {\n    width: 100%;\n    text-align: center;\n  }\n\n  .nav-menu .item-nav:hover {\n    background-color: #1d66a3;\n  }\n\n  .nav-menu-m {\n    display: inline-block !important;\n  }\n\n  .layer-content {\n    width: 190px !important;\n  }\n\n  .map-title {\n    width: 70px !important;\n  }\n\n  .layer-menu-siderbar {\n    width: 200px !important;\n  }\n\n  ::ng-deep .mat-list-base .mat-list-item .mat-list-item-content,\n  .mat-list-base .mat-list-option .mat-list-item-content {\n    padding: 0 5px !important;\n  }\n\n  .layer-style-list .material-icons {\n    font-size: 18px !important;\n    padding-right: 4px !important;\n  }\n\n  .show-legeand-sidebar {\n    bottom: 40px !important;\n  }\n\n  .layers-name {\n    max-width: 70px !important;\n  }\n\n  .layer-style-list img {\n    width: 20px;\n    height: 20px;\n  }\n\n}\n\n.close-btn {\n  text-align: right;\n  font-size: 16px;\n  margin-top: 5px;\n  position: absolute;\n  right: 8px;\n}\n\n.close-btn .material-icons {\n  padding: 5px;\n  border: 1px #ddd solid;\n  border-radius: 50px;\n  background-color: #fff;\n}\n\n.mat-toolbar-multiple-rows {\n  border-bottom: 1px #eee solid;\n  min-height: 50px;\n}\n\n\n.tools-operation {\n  position: relative;\n  background: #fff;\n  left: 0;\n  right: 0;\n  margin: 0 auto;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 9;\n  padding: 2px 0px 5px;\n}\n\n\n\n.mat-cards {\n  border-top: 1px solid #003561;\n  border-bottom: 1px solid #003561;\n  padding: 8px !important;\n}\n\n.mat-stepperdiv {\n  height: calc(100vh - 50px);\n  max-height: unset;\n}\n\n.bodyview {\n  position: relative;\n  z-index: 1;\n  display: block;\n  overflow: hidden;\n}\n\n.scrolldivs {\n  height: calc(100vh);\n}\n\n.side-list {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.mat-tools {\n  height: 50px;\n}\n\n:host ::ng-deep .show-legeand-sidebar {\n  background: transparent !important;\n}\n\n.desktopview {\n  flex: 1 1 100%;\n  box-sizing: border-box;\n  /* max-height: 20%; */\n  margin: 0px 10px 0px 10px;\n  border: 9px solid #20609c;\n  border-radius: 9px;\n  height: 94vh;\n  z-index: 99999;\n}\n\n.divflex {\n  position: relative;\n}\n\n.menu-divflex {\n  border-right: 1px solid #909090;\n  width: 70px;\n  background: #fff;\n}\n\n.details .menuBtn {\n  line-height: 30px !important;\n}\n\nimg.img-dash {\n  height: 17px;\n  margin-right: 8px;\n}\n\n.logo-dash {\n  height: 24px;\n  position: relative;\n  top: 1px;\n}\n\n.dflex {\n  display: flex;\n}\n\n:host ::ng-deep .mat-menu-content:not(:empty) {\n  padding: 0 !important;\n}\n\n.headmap {\n  padding: 5px 7px;\n  background: #ddd;\n  border-radius: 0px;\n}\n\n.headmap h2 {\n  font-size: 14px;\n}\n\n.add-icon {\n  color: #fff !important;\n}\n\n.share-icon {\n  font-size: 20px;\n  height: 20px;\n  width: 20px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
